import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "installation"
    }}>{`Installation`}</h1>
    <p>{`After download the full package from CodeCanyon, you will have `}<inlineCode parentName="p">{`rnb-seasonal-pricing.zip`}</inlineCode>{` file inside your main package. You can install it from WordPress back-end or
manually.`}</p>
    <h2 {...{
      "id": "install-from-wordpress-back-end"
    }}>{`Install from WordPress back-end:`}</h2>
    <pre><code parentName="pre" {...{}}>{`1. Go to wordpress Dashboard -> plugins -> add new.
2. From here click upload plugins button, then you will find the plugin upload window.
3. Upload rnb-seasonal-pricing.zip then click install now button.
4. After successfully install the plugin then active it.
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      